import {Siparis} from './siparis';
import {Irsaliye} from './irsaliye';

export class IrsaliyelerPage {

  currentPage: number;
  pageCount: number;
  pageSize: number;
  rowCount: number;
  firstRowOnPage: number;
  lastRowOnPage: number;
  private pResults: Irsaliye[];


  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    Object.assign(this, obj);
  }

  public get results(): Irsaliye[] {
    return this.pResults;
  }

  public set results(list: Irsaliye[]) {
    if (list != null) {
      this.pResults = list.map(t => new Irsaliye(t));
    }
  }

}
